import React from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import 'react-app-polyfill/stable'; // Core-js'in tam sürümünü içeren polyfill'leri ekler
import './index.css';
import { BrowserRouter } from "react-router-dom"
import Store from './Store/Store';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import App from './App';
import { clear_uid, set_email, set_uid, set_username } from './Action/Action';

var root_ = document.getElementById('root')

createRoot(root_).render(
  <BrowserRouter>
    <Provider store={Store}>

      <App />
    </Provider>
  </BrowserRouter>
)

